export default interface PaymentDoc {
    paymentDocType: PaymentDocType;
    id: string;
    status: PaymentDocStatus;
    currencyCode: string;
    total: number;
    date: number;
    lineItems: { id: string; quantity: number }[];
    hasAdvanceCharges: boolean;
}

export interface PaymentDocDownloadLink {
    url: string;
    validTill: number;
}

export enum PaymentDocType {
    CREDIT_NOTE = 'CREDIT_NOTE',
    INVOICE = 'INVOICE',
}

export enum PaymentDocStatus {
    // Invoice
    PAID = 'PAID',
    POSTED = 'POSTED',
    PAYMENT_DUE = 'PAYMENT_DUE',
    NOT_PAID = 'NOT_PAID',
    VOIDED = 'VOIDED',
    PENDING = 'PENDING',
    // Credit Note
    ADJUSTED = 'ADJUSTED',
    REFUNDED = 'REFUNDED',
    REFUND_DUE = 'REFUNDED_DUE',
    _UNKNOWN = '_UNKNOWN',
}
